import { t } from 'i18next'
import React from 'react'
import CustomImageComponent from '../../components/CustomImageComponent'

const GrowthSec = ({ data }) => {
    return (
        <section className="freelancers-section-two">
            <div className="container aos-init aos-animate" data-aos="fade-up" data-aos-duration="1500">
                {/* <div>{data}</div> */}
                <div className='text-center' dangerouslySetInnerHTML={{ __html: `${data?.content}` }} />
                {/* <h2 className="title text-center">{t("freelance_header")}</h2>
                <h5 className="sub-title text-center">{t("freelance_desc")}
                </h5> */}
                <div className="btn-block">
                    <a target='_blank' href={data?.urlLinkA}><CustomImageComponent src={data?.imageLinkA} alt={"iOS"} className={"img-fluid "} /></a>
                    <a target='_blank' href={data?.urlLinkB}><CustomImageComponent src={data?.imageLinkB} alt={"Google Play"} className={"img-fluid "} /></a>
                </div>
            </div>
        </section>

    )
}

export default GrowthSec